import { arrayOrObjectToCamelCase } from 'helpers'

export const WGCWX_BATTLE_SCHEDULE_REQUEST = 'wgcwx_battle_schedule/REQUEST'
export const WGCWX_BATTLE_SCHEDULE_SUCCESS = 'wgcwx_battle_schedule/SUCCESS'
export const WGCWX_BATTLE_SCHEDULE_ERROR = 'wgcwx_battle_schedule/ERROR'

export function requestBattleSchedule() {
    return async (dispatch, getState) => {
        const { settings } = getState()

        dispatch({ type: WGCWX_BATTLE_SCHEDULE_REQUEST })
        try {
            const url = `${settings.gatewayHost}/global_map/wgapi/battle_schedule/`
            const response = await fetch(url, { credentials: 'include' })
                .then(r => {
                    return r.json().then(data => ({ ok: r.ok, body: data }))
                })

            if (!response.ok) {
                const err = response.body
                throw new Error(err.title || err.description)
            }

            dispatch({
                type: WGCWX_BATTLE_SCHEDULE_SUCCESS,
                payload: {
                    battleSchedule: arrayOrObjectToCamelCase(response.body),
                },
            })
        } catch (error) {
            dispatch({
                type: WGCWX_BATTLE_SCHEDULE_ERROR,
                payload: {
                    errorMessage: error.message,
                },
            })
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/wgcwx_battle_schedule.js